import styled from 'styled-components'
import { Box } from '../components/box'
import { Text } from '../components/text'
import { Image } from '../components/image'
import { Subtitle } from '../components/title'
import { RRSS } from '../components/rrss'

const StyledProfile = styled(Box)`
    gap: 2em;

    a {
        text-decoration: none;
    }

    @media only screen and (min-width: 768px) {
        flex-direction: row;
    }

    @media print {
        flex-direction: row;
        align-items: center;
        gap: 1rem;

        ${ Image } {
            width: 9rem;
            align-self: center;
        }

        > ${ Box }:first-child {
            align-items: center;
        }

        > ${ Box }:first-child > ${ Box } {
            gap: 0.2em;
            align-items: center;
            text-align: center;
        }
    }
`

export const Profile = ({ data }) => <StyledProfile>
    <Box gap='1em'>
        <Image src="jsday.jpeg" width="300px" border />
        <Box gap='0'>
            <Subtitle
                style={{ margin: 0 }}
                color="main"
                bold
                size="2em"
            > Pablo Roizo </Subtitle>
            <a href="mailto:pablo.deving@gmail.com">
                <Text>pablo.deving@gmail.com</Text>
            </a>
            <RRSS/>
        </Box>
    </Box>
    <Text>
        { data.about }
    </Text>
</StyledProfile>
